"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = Content;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    wrapper: {
      borderRadius: '32px',
      background: theme.palette.grey[50],
      minHeight: 'calc(100vh - 16px)'
    }
  };
});

function Content(_ref) {
  var children = _ref.children,
      textAlign = _ref.textAlign,
      _ref$boxSizing = _ref.boxSizing,
      boxSizing = _ref$boxSizing === void 0 ? 7 : _ref$boxSizing;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: boxSizing
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    m: 1,
    p: 2,
    textAlign: textAlign || 'center',
    className: classes.wrapper
  }, children));
}

;